import type { DashboardWidgetConfiguration } from './widget-definition';
import { period } from './query-period';

export const inventoryEventTrendWidget: DashboardWidgetConfiguration = {
  widgetId: "inventory.event-trend",
  name: "Inventory activity",
  description: "Inventory activity across the selected period.",
  apps: [
    "home",
    "inventory",
  ],
  template: "graph",
  query: {
    kind: "graph",
    valueQuery: {
      version: 1,
      source: "inventory.stock-events",
      ...period(30),
      select: [
        {
          type: "aggregate",
          function: "count_distinct",
          field: "event_id",
          as: "value",
        },
      ],
    },
    graphQueries: [
      {
        name: "Events",
        query: {
          version: 1,
          source: "inventory.stock-events",
          ...period(30),
          select: [
            {
              type: "field",
              field: "created_at",
              bucket: "day",
              as: "day",
            },
            {
              type: "aggregate",
              function: "count_distinct",
              field: "event_id",
              as: "value",
            },
          ],
          group_by: [
            {
              field: "created_at",
              bucket: "day",
            },
          ],
          order_by: [
            {
              ref: "day",
              direction: "asc",
            },
          ],
        },
        type: "area",
        color: "#206bc4",
        lineWidth: 2,
        fillOpacity: 0.16,
        valueMultiplier: 1,
      },
    ],
  },
  inputs: {
    title: "Inventory activity",
    valueFormat: "number",
    valueMultiplier: 1,
    graphPadding: true,
    chartHeight: 112,
    curve: "smooth",
  },
  dummyData: {
    value: "186",
    series: [
      18,
      24,
      20,
      32,
      29,
      41,
      48,
    ],
  },
  limits: {
    minWidth: 3,
    maxWidth: 12,
    minHeight: 2,
    maxHeight: 6,
    defaultWidth: 6,
    defaultHeight: 3,
  },
};
